/** Finance menu labels → Spatie permission names (match backend RestrictsFinanceAccess). */
export const FINANCE_SALES_MENU_PERMISSIONS = {
  Estimates: "Estimate.Read",
  Invoices: "Invoice.Read",
  Payments: "Payment.Read",
  Expenses: "Expense.Read",
  "Provident Fund": "ProvidentFund.Read",
  Taxes: "Tax.Read",
};

export const FINANCE_ACCOUNTING_MENU_PERMISSIONS = {
  Categories: "AccountCategory.Read",
  Budgets: "Budget.Read",
  "Budget Expenses": "Budget.Read",
  "Budget Revenues": "Budget.Read",
};

export const FINANCE_SALES_ROUTE_RULES = [
  {
    permission: "Estimate.Read",
    moduleKey: "fa_sales",
    matches: (path) => path === "/sales/estimates",
  },
  {
    permission: "Invoice.Read",
    moduleKey: "fa_sales",
    matches: (path) =>
      path === "/sales/invoices" ||
      path === "/sales/invoices/add-invoices" ||
      /^\/sales\/invoices\/\d+(\/edit)?$/.test(path),
  },
  {
    permission: "Payment.Read",
    moduleKey: "fa_sales",
    matches: (path) => path === "/sales/payments",
  },
  {
    permission: "Expense.Read",
    moduleKey: "fa_sales",
    matches: (path) => path === "/sales/expenses",
  },
  {
    permission: "ProvidentFund.Read",
    moduleKey: "fa_sales",
    matches: (path) => path === "/sales/provident-fund",
  },
  {
    permission: "Tax.Read",
    moduleKey: "fa_sales",
    matches: (path) => path === "/sales/taxes",
  },
];

export const FINANCE_ACCOUNTING_ROUTE_RULES = [
  {
    permission: "AccountCategory.Read",
    moduleKey: "fa_accounting",
    matches: (path) => path === "/accounting/categories",
  },
  {
    permission: "Budget.Read",
    moduleKey: "fa_accounting",
    matches: (path) =>
      path === "/accounting/budgets" ||
      path === "/accounting/budget-expenses" ||
      path === "/accounting/budget-revenues",
  },
];

export function isFinanceSalesMenuValue(menuValue) {
  return Object.prototype.hasOwnProperty.call(
    FINANCE_SALES_MENU_PERMISSIONS,
    menuValue,
  );
}

export function isFinanceAccountingMenuValue(menuValue) {
  return Object.prototype.hasOwnProperty.call(
    FINANCE_ACCOUNTING_MENU_PERMISSIONS,
    menuValue,
  );
}

export function financeSalesPermissionForMenu(menuValue) {
  return FINANCE_SALES_MENU_PERMISSIONS[menuValue] || null;
}

export function financeAccountingPermissionForMenu(menuValue) {
  return FINANCE_ACCOUNTING_MENU_PERMISSIONS[menuValue] || null;
}

export function matchFinanceSalesRoute(path) {
  if (!path || !path.startsWith("/sales")) return null;
  return FINANCE_SALES_ROUTE_RULES.find((rule) => rule.matches(path)) || null;
}

export function matchFinanceAccountingRoute(path) {
  if (!path || !path.startsWith("/accounting")) return null;
  return FINANCE_ACCOUNTING_ROUTE_RULES.find((rule) => rule.matches(path)) || null;
}

export function canShowFinanceSalesMenuForEmployee(menuValue, hasPermission) {
  const permission = financeSalesPermissionForMenu(menuValue);
  if (!permission) return false;
  return hasPermission(permission);
}

export function canShowFinanceAccountingMenuForEmployee(menuValue, hasPermission) {
  const permission = financeAccountingPermissionForMenu(menuValue);
  if (!permission) return false;
  return hasPermission(permission);
}

export function canAccessFinanceSalesRoute(path, hasPermission) {
  const rule = matchFinanceSalesRoute(path);
  if (!rule) return path === "/sales" || path === "/sales/";
  return hasPermission(rule.permission);
}

export function canAccessFinanceAccountingRoute(path, hasPermission) {
  const rule = matchFinanceAccountingRoute(path);
  if (!rule) return path === "/accounting" || path === "/accounting/";
  return hasPermission(rule.permission);
}

export function canAccessFinanceAdminRoutes(hasPermission) {
  return (
    hasPermission("Invoice.Read") ||
    hasPermission("Estimate.Read") ||
    hasPermission("Payment.Read") ||
    hasPermission("Expense.Read") ||
    hasPermission("Tax.Read") ||
    hasPermission("ProvidentFund.Read") ||
    hasPermission("Budget.Read") ||
    hasPermission("AccountCategory.Read")
  );
}
